import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { isLoggedInAsAdmin } from '@app/app.reducer';
import { select, Store } from '@ngrx/store';
import { map, take } from 'rxjs';

@Injectable()
export class LoginGuardAdmin implements CanActivate {
  readonly #router = inject(Router);
  readonly #store = inject(Store);

  canActivate() {
    return this.#store.pipe(
      select(isLoggedInAsAdmin),
      map((isLoggedInAsAdmin) => {
        if (isLoggedInAsAdmin) {
          return isLoggedInAsAdmin;
        }

        this.#router.navigate(['/']);

        return false;
      }),
      take(1)
    );
  }
}
